<template>
	<div class="poi poi-landscape" v-if="poi">
        <div class="poi-content">
            <WFScrollableArea class="poi-content-left" v-if="poi">
                <div>
                    <div class="poi-name" v-html="poi.getName(language) || ''"></div>
                    <div class="poi-description" v-html="poi.getDescription(language) || ''"></div>
                </div>
            </WFScrollableArea>
            <div class="poi-content-right">
                <div class="img-placeholder">
                    <img :src="shopPhoto"/>
                </div>
                
                <div class="poi-buttons">
                    <div class="poi-logo-holder">
                        <img :src="shopLogo" v-if="shopLogo !=''"/>
                    </div>
                    <button class="btn btn-border btn-lg" @click="showOnMap" data-translation-element="show-on-map">Kuva kaardil</button>
                    <button class="btn btn-border btn-lg" @click="showPath"><Icon name="path"/><label data-translation-element="show_path">Näita teekonda</label></button>
                </div>
            </div>
        </div>
        <div class="poi-footer">
            <div class="poi-footer-left">
                <div class="poi-email" v-if="poi.email !== ''"><Icon name="email"/><label>{{poi.email}}</label></div>
                <div class="poi-phone" v-if="poi.phone !== ''"><Icon name="phone"/><label>{{poi.phone}}</label></div>
            </div>
            <div class="poi-footer-right">
                <button class="btn btn-close" @click="close()">
                    <label data-translation-element="close">Sulge</label>
                    <div class="circle"><Icon name="close"/></div>
                </button>
            </div>
        </div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { WFScrollableArea} from '@3dwayfinder/wayfinder-vue-components'

export default {
	name: "POI",
    components: {
        WFScrollableArea
    },
	computed: {
		...mapState('wf', ['language']),
		hasShowPathListener(){
			return !!(this.$listeners && this.$listeners.showPath);
		},
        shopLogo() {
            return this.poi ? this.poi.getAttributeString("logo") : "";
        },
        shopPhoto () {
            console.log('shopPhoto', this.poi.getAttributeString("photo"))
            return this.poi ? this.poi.getAttributeString("photo") : "";
        }
	},
	props: {
		poi: {
			type: Object,
			default: null
		},
		showLogo: {
			type: Boolean,
			default: false
		},
		showName: {
			type: Boolean,
			default: true
		},
		showPathButton: {
			type: Boolean,
			default: false
		},
		showDescription: {
			type: Boolean,
			default: false
		},
		showRoomID: {
			type: Boolean,
			default: false
		},
		showFloor: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		language () {
			if (this.$wayfinder) {
				this.show_path = this.$wayfinder.translator.get('show_path');
			}
		},
        poi () {
        
        }
	},
	methods: {
		showPath () {
			if (this.poi) {
				if (this.hasShowPathListener) {
					this.$emit('showPath', this.poi);
				}
				else {
					this.$wayfinder.showPath(this.poi.getNode(), this.poi);
				}
			}
		},
        showOnMap () {
            this.$emit('showOnMap', this.poi);
        },
		open (type) {
			if (type && this.poi[type]) {
				if (type === 'shop_email') {
					window.open('mailto:' + this.poi[type], '_system')
				}
				else if (type === 'shop_phone') {
					window.open('tel:' + this.poi[type], '_system')
				}
				else {
					window.open(this.poi[type], '_system')
				}
			}
		},
        close () {
            this.$emit('close');
        },
		getImage () {
			if (this.poi.getBackgroundUrl())
				return 'url("' + this.poi.getBackgroundUrl() + '")';
				
			else if (this.poi.getIconUrl()) {
				return 'url("' + this.poi.getIconUrl() + '")';
			}
			else {
				return false;
			}
		},
		isImage () {
			if(this.poi.getBackgroundUrl()) return "image-background";
			else if (this.poi.getIconUrl()) return "image-logo";
			else return "image-none";
		},
		truncate (str, len) {
			if (str && str.length > len) {
				return str.substring(0, len) + '...';
			}
			else {
				return str;
			}
		}
	},
	data: function () {
		return {
			show_path: 'Show Path',
		}
	}
};
</script>

<style lang="less">
    @import '../css/variables';
    .poi-landscape {
        .poi {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            overflow: hidden;
        }

        .poi-header {
            font-size: 1.4rem;
            display: flex;
            flex-basis: 5.6rem;
            flex-grow: 0;
            flex-shrink: 0;
            justify-content: space-between;
            padding: 1.8rem 7.2rem;
            align-items: center;
            border-bottom: 0.2rem solid rgba(224, 223, 223, 1);

            .poi-header-right {
                justify-content: flex-end;
                & > * {
                    margin-left: 6rem;
                }
            }

            .poi-header-left {
                & > * {
                    margin-right: 6rem;
                }
            }

            & > div {
                display: flex;
                align-items: center;
                line-height: 1.4rem;

                .icon {
                    height: 1.4rem;
                    margin-right: 0.8rem;

                    --color1: rgba(167, 169, 172, 1);

                }

                & > * {
                    display: flex;
                    align-items: center;
                }
            }
        }

        .poi-name {
            font-size: 3.2rem;
            text-transform: uppercase;
            font-weight: 500;
            line-height: 1.2;
        }

        .poi-content {
            flex-grow: 1;
            flex-shrink: 1;
            display: flex;
            padding: 2.4rem;
            padding-bottom: 1.4rem;
            font-size: 1.6rem;
            line-height: 2.4rem;
            overflow: hidden;

            .poi-content-left {
                font-size: 1.8rem;
                display: flex;
                flex-direction: column;
                padding-right: 2rem;
                margin-right: 1rem;
                flex-grow: 0;
                flex-shrink: 1;
            }

            .poi-content-right {
                width: 23.8rem;
                display: flex;
                flex-direction: column;
                height: 100%;

                .btn {
                    width: 100%;
                    margin-top: 0.8rem;
                    justify-content: center;
                }

                
                .poi-logo-holder {
                    height: 4.8rem;
                    margin-top: 1.6rem;
                }

                .poi-buttons img {
                    height: 4.8rem;
                    width: 100%;
                    object-fit: contain;
                    
                }
            }

            .img-placeholder {
                width: 23.8rem;
                height: 23.8rem;

                img {
                    width: 23.8rem;
                    height: 23.8rem;
                    object-fit: cover;
                }
            }
        }

        .poi-footer {
            border-top: 0.2rem solid rgba(224, 223, 223, 1);
            display: flex;
            justify-content: space-between;
            padding: 1.1rem 2.4rem;
            flex-basis: 6.4rem;
            flex-grow: 0;
            flex-shrink: 0;
            background-color: @secondary-background;
            font-size: 1.4rem;

            .poi-email {
                margin-right: 3.4rem !important;
            }

            .icon {
                height: 1.6rem !important;
                font-weight: 500;
                margin-top: 0.2rem;
            }

            .poi-footer-left {
                width: auto;


                .icon {
                    margin-right: 0.8rem;
                }
                
                & > * {
                    margin-right: 6rem;
                }
            }

            .poi-footer-right {
                justify-content: flex-end;
                flex-grow: 1;
                margin-right: -1.5rem;
            }

            img {
                height: 4.8rem;
            }

            & > div {
                display: flex;
                align-items: center;

                & > * {
                    display: flex;
                    align-items: center;
                    
                }
            }

            .btn {
                width: 50%;
                justify-content: center;
            }
        }
    }
</style>
